module.exports = __webpack_public_path__ + "static/media/photo1.e751e259.png";